// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3dAtq","languagesGrid":"Form_languagesGrid__3_3oi","preview":"Form_preview__lFkhs","label":"Form_label__7gekh","messages":"Form_messages__2FX1U"};